module.exports = __webpack_public_path__ + "img/nantong.0cbf6309.png";